import React from 'react';
import { StyleSheet, View, Text, TextInput } from './base_components';
import Link from './buttons/link';
import RadioList from './radio_list';
import UserSelect from './user_select';

const styles = StyleSheet.create({
  propList: {
    paddingRight: '2rem',
    paddingBottom: '2rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  column: {
    minWidth: '30rem',
    flex: 1,
    flexDirection: 'column',
    borderRightWidth: 1,
    borderRightColor: 'var(--prop-list-border-color)',
  },
  prop: {
    marginLeft: '2rem',
    marginRight: '2rem',
    flexDirection: 'column',
  },
  label: {
    marginTop: '2rem',
    color: 'var(--prop-list-label-color)',
    fontSize: '1.35rem',
    fontWeight: '500',
  },
  detail: {
    marginTop: '0.5rem',
    maxWidth: '50rem',
    color: 'var(--prop-list-detail-color)',
    fontSize: '1.25rem',
    lineHeight: '2rem',
    fontWeight: '400',
  },
  valueView: {
    marginTop: '0.5rem',
    flexDirection: 'column',
    minHeight: '2rem',
  },
  value: {
    color: 'var(--prop-list-value-color)',
    fontSize: '1.35rem',
    fontWeight: '500',
    wordBreak: 'break-all',
    overflowWrap: 'break-word',
  },
  link: {
    color: 'var(--link-text-color)',
    textDecoration: 'underline',
  },
  radioSpacer: {
    height: '0.5rem',
  },
  radio: {
    marginTop: '0.25rem',
  },
  userSelect: {
    marginTop: '0.25rem',
  },
  inputView: {
    marginTop: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    alignSelf: 'stretch',
    maxWidth: '40rem',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: 'var(--input-border-color)',
    backgroundColor: 'var(--input-bg-color)',
  },
  disabled: {
    borderColor: 'var(--input-disabled-border-color)',
    backgroundColor: 'var(--input-disabled-bg-color)',
  },
  input: {
    flex: 1,
    height: '4rem',
    color: 'var(--input-text-color)',
    fontSize: '1.5rem',
    ':disabled': {
      color: 'var(--input-disabled-color)',
    },
  },
  lastColumn: {
    borderRightWidth: 0,
  },
  lastProp: {
    marginBottom: 0,
  },
});

export default function PropList(props) {
  const { style, columns } = props;

  return (
    <View style={[styles.propList, style]}>
      {columns.map((column, i) => (
        <Column
          key={i}
          column={column}
          editing={props.editing}
          onChange={props.onChange}
          last={i === columns.length - 1}
        />
      ))}
    </View>
  );
}
function Column(props) {
  const { column, last } = props;
  return (
    <View style={[styles.column, last ? styles.lastColumn : null]}>
      {column.map((cell, i) => (
        <Cell
          key={i}
          cell={cell}
          editing={props.editing}
          onChange={props.onChange}
          last={i === column.length - 1}
        />
      ))}
    </View>
  );
}
function Cell(props) {
  const { cell, editing, onChange } = props;
  const { label, detail, value, style, last, radio, input, userSelect } = cell;
  function _onChange(new_value) {
    onChange(props.cell, new_value);
  }

  let content: any = null;
  if (editing && radio) {
    content = (
      <>
        <View style={styles.radioSpacer} />
        <RadioList
          style={styles.radio}
          value={value}
          onChange={_onChange}
          {...radio}
        />
      </>
    );
  } else if (editing && userSelect) {
    content = (
      <>
        <UserSelect
          style={styles.userSelect}
          value={value}
          onChange={_onChange}
          {...userSelect}
        />
      </>
    );
  } else if (editing && input) {
    const { suffix, ...other } = input;
    content = (
      <View style={[styles.inputView, other.disabled ? styles.disabled : null]}>
        <TextInput
          style={styles.input}
          value={value}
          onChangeText={_onChange}
          {...other}
        />
        {suffix ? <Text style={styles.value}>{suffix}</Text> : null}
      </View>
    );
  } else {
    const prefix = cell?.valuePrefix ?? '';
    const suffix = cell?.valueSuffix ?? '';
    const view_value = cell.viewValue ?? cell.value;
    const val =
      cell?.emptyValue && !view_value
        ? cell.emptyValue
        : prefix + view_value + suffix;
    let inner: any = null;
    if (cell?.url) {
      inner = (
        <Link url={cell.url}>
          <Text style={[styles.value, styles.link, style]}>{val}</Text>
        </Link>
      );
    } else {
      inner = <Text style={[styles.value, style]}>{val}</Text>;
    }
    content = <View style={styles.valueView}>{inner}</View>;
  }

  let outer: any = null;
  if (!cell.editOnly || editing) {
    outer = (
      <View style={[styles.prop, last ? styles.lastProp : null]}>
        {label ? <Text style={styles.label}>{label}</Text> : null}
        {detail ? <Text style={styles.detail}>{detail}</Text> : null}
        {content}
      </View>
    );
  }
  return outer;
}
